export default __webpack_public_path__ + "static/martin-93051c0b2d62377b0cb14a88cff0ccd9.png";